export default {
    model: {
        event: 'input'
    },
    props: {
        value: {
            required: false,
            default: null
        }
    },
    computed: {
        country: {
            get() {
                return this.value;
            },
            set(newCountry) {
                this.$emit('input', newCountry)
            }
        }
    }
}